module.exports = __webpack_public_path__ + "img/radio-minnal.891948ec.jpg";